import * as AuthToken from '../../../services/auth/token';
import router from '../../../router';

const { KLICKART_AUTH_URI } = process.env;

export default ({ rootState }) => {
  const { redirect } = rootState.route.query;
  let { token } = rootState.route.query;

  if (!token) {
    window.location = KLICKART_AUTH_URI;
    return;
  }

  token = token.replace(/\s/g, '+');

  AuthToken.set(token);

  if (redirect) {
    window.location = redirect;
    return;
  }

  router.push({ name: 'Index' });
};



// WEBPACK FOOTER //
// ./src/screens/Auth/store/actions.js